import ReactDOM from "react-dom";
import React, { useState, useContext, useEffect } from "react";
import objects from "../../objects";
import "./Wycieczka.scss";
import "../Button/Button.scss";
import tv from "../../assets/wycieczka/tvbezcont.gif";

import arrow from "../../assets/rarr.svg";
import arrow_orange from "../../assets/larr.svg";
import pause from "../../assets/pause-button.svg";
import pauseOrange from "../../assets/pause-orange.svg";
import gosc from "../../assets/wycieczka/goscnew.gif";
import goscplay from "../../assets/wycieczka/gosc_gada_pop.gif";
import m0 from "../../assets/wycieczka/xsounds/00.mp3"
import m0en from "../../assets/wycieczka/xsounds/00en.mp3"
import Sound from "react-sound";

import { BuildingsContext } from "../../bContext";

import WycOne from "./Pages/WycOne";
import WycTwo from "./Pages/WycTwo";
import WycThree from "./Pages/WycThree";
import WycFour from "./Pages/WycFour";
import WycFive from "./Pages/WycFive";
import WycSix from "./Pages/WycSix";
import WycSeven from "./Pages/WycSeven";
import WycEight from "./Pages/WycEight";
 import WycNine from "./Pages/WycNine";

const Wycieczka = ({ isShowing, hide, props }) => {
  const {switchToEnglish, play, setPlay, wycPage, setWycPage, pageRoad, setPageRoad, wycPlay, setWycPlay, speakVol, wycStop, setWycStop } = useContext(BuildingsContext);

  const [left, setLeft] = useState(0);
  const [right, setRight] = useState(0);
  
  const [playColor, setPlayColor] = useState(false);



  useEffect(() => {
    if (wycStop === true && wycPage <= 8) {
      const timer = setTimeout(() => {
        setWycPage(wycPage + 1) 
        setWycStop(false)
         setWycPlay(Sound.status.PLAYING);
      }, 1000);
      return () => clearTimeout(timer);
    
       
    }
  }, [setWycPage, setWycPlay, setWycStop, wycPage, wycStop])

  useEffect(() => {
    if (wycStop === true && wycPage === 9){
      const timer = setTimeout(() => {
        hide();
        setWycPage(0)
        setPageRoad(0)
        setWycPlay(Sound.status.PLAYING);
        setPlay(true);
        setWycStop(false);
      
      }, 1200);
      return () => clearTimeout(timer);
    }
  }, [ setPageRoad, setWycPage, setWycStop, wycPage, wycStop])


  // console.log(wycPage)

  return isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-overlay-wyc " />
          <div className={wycPage === 9 ? "modal-wrapper-wyc-last wycieczkaka " : "modal-wrapper-wyc wycieczkaka"}>
            {wycPage === 0 && (
              
              <div className="mini-header-wyc">
                <h3>{!switchToEnglish ? "WITAMY!" : "WELCOME!" }</h3>
              </div>
            )}

            <div
              onClick={() => {
                hide();
                setWycPage(0)
                setPageRoad(0)
                setWycPlay(Sound.status.PLAYING);
                setPlay(true);
                setWycStop(false);
              }}
              
              className={wycPage === 9 ? "mini-exit-last" : "mini-exit"}
            >
              <svg
                className="xsvg"
                height="365.696pt"
                viewBox="0 0 365.696 365.696"
                width="365.696pt"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m243.1875 182.859375 113.132812-113.132813c12.5-12.5 12.5-32.765624 0-45.246093l-15.082031-15.082031c-12.503906-12.503907-32.769531-12.503907-45.25 0l-113.128906 113.128906-113.132813-113.152344c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503907-12.5 32.769531 0 45.25l113.152344 113.152344-113.128906 113.128906c-12.503907 12.503907-12.503907 32.769531 0 45.25l15.082031 15.082031c12.5 12.5 32.765625 12.5 45.246093 0l113.132813-113.132812 113.128906 113.132812c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082031c12.5-12.503906 12.5-32.769531 0-45.25zm0 0" />
              </svg>
            </div>

            <div className="modal-wyc">
            {play && wycPlay === Sound.status.PLAYING && speakVol > 0  ? 
              <img className="goscplay" src={goscplay} alt="" /> 
              :
              <img className="gosc" src={gosc} alt="" /> }
              {/* ==================================================================================================== */}
              {wycPage === 0 && (
             <>
                  <Sound 
                  url={switchToEnglish === false ?  m0 : m0en}
                  playStatus={ wycPlay}
                  onFinishedPlaying={() => {
                    setWycPlay(Sound.status.STOPPED);
                    setWycStop(true);
                  }}
                  
                  volume={speakVol}
                  />
                   {pageRoad === 3 ?
                <div className="tv">
                  <img src={tv} alt="" /> 
                  
                  {/* <img src={tvscreen} alt="" /> */}
                </div>
                :
                <div>asda</div>
                  }
             </>   
              )}
              {wycPage === 1 && <WycOne />}
              {wycPage === 2 && <WycTwo />}
              {wycPage === 3 && <WycThree />}
              {wycPage === 4 && <WycFour />}
              {wycPage === 5 && <WycFive />}
              {wycPage === 6 && <WycSix />}
              {wycPage === 7 && <WycSeven />}
              {wycPage === 8 && <WycEight />}
              {wycPage === 9 && <WycNine />}

              <div className={wycPage === 9 ? "btn-nav-wyc-last" : "btn-nav-wyc"}>
                <div
                  className={wycPage === 0 ? "ins-btn-wyc2 wyc-hidden" : "ins-btn-wyc2"}
                  onClick={() => {
                    wycPage <= 0 ? setWycPage(0) : setWycPage(wycPage - 1);
                    setWycPlay(Sound.status.PLAYING);
                    setPlay(true);
                    setWycStop(false);
                  }}
                  onMouseOver={() => setLeft(1)}
                  onMouseLeave={() => setLeft(0)}
                >
                  <img
                    className={wycPage === 0 ? "arrow_left opa2" : "arrow_left"}
                    src={left === 1 ? arrow_orange : arrow}
                    alt=""
                  />
                  <p className={left === 1 ? "pon" : "poff"}>
                    {switchToEnglish === false ? 
                    "POPRZEDNIA TABLICA"
                    :
                    "PREVIOUS INFORMATION BOARD"
                  }
                   
                  </p>
                </div>

                <div
                  className="play-pause-wyc"
                  onClick={() => {
                    if (play === false) {
                      setWycPlay(Sound.status.PLAYING)
                      setPlay(true);
                    } else if (play === true) {
                      setPlay(false);
                      setWycPlay(Sound.status.STOPPED)
                    }
                  }}
                  onMouseOver={() => setPlayColor(true)}
                  onMouseLeave={() => setPlayColor(false)}
                >
                  {play ? (
                    <p className={playColor === true ? "pon" : "poff"}>STOP</p>
                  ) : (
                   <p className={playColor === true ? "pon" : "poff"}>
                         {switchToEnglish === false ? 
                    "ODTWÓRZ"
                    :
                    "PLAY"
                  }
                     </p>
                  )}

                  {/* <button onClick={() => handleStopVideo()}>
                      sassssstop
                    </button> */}
                </div>

                <div
                  className="ins-btn-wyc"
                  onClick={() => {
                    wycPage <= 8 ? setWycPage(wycPage + 1) : setWycPage(9);
                    setWycPlay(Sound.status.PLAYING);
                    setPlay(true);
                    setWycStop(false);
                  }}
                  onMouseOver={() => setRight(1)}
                  onMouseLeave={() => setRight(0)}
                >
                  <p className={right === 1 ? "pon" : "poff"}>
                  {switchToEnglish === false ? 
                    "NASTĘPNA TABLICA"
                    :
                    "NEXT INFORMATION BOARD"
                  }
                 
                  </p>
                  <img
                    className={wycPage === 9 ? "opa2" : "arrows2"}
                    src={right === 1 ? arrow_orange : arrow}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
    : null;
};

export default Wycieczka;
